import "./App.css";

function Title() {
  return (
    <div id="title">
      <h1 className="text">DISCARDEDUNWANTED</h1>
    </div>
  );
}

function App() {
  return (
    <div className="App">
      <Title />
    </div>
  );
}

export default App;
